(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-wearing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SAVE = navigator.connection && navigator.connection.saveData;
    var MOTION_OK = !REDUCE && !SAVE;

    document.querySelectorAll('[data-skw]').forEach(function (root) {
      var rail = root.querySelector('[data-skw-rail]');
      var nav = root.querySelector('[data-skw-nav]');
      var prev = root.querySelector('[data-skw-prev]');
      var next = root.querySelector('[data-skw-next]');
      var prog = root.querySelector('[data-skw-prog]');
      var bar = root.querySelector('[data-skw-bar]');
      if (!rail) return;

      /* ---------- silent clips, played only while on screen ------------- */
      var vids = [].slice.call(rail.querySelectorAll('video'));
      vids.forEach(function (v) {
        // Belt and braces. The markup already says muted; a bfcache restore can
        // hand back an element with the property flipped, and this section must
        // never make a sound.
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.removeAttribute('controls');
      });

      if (vids.length && MOTION_OK && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) {
              v.muted = true;
              // Autoplay can still be refused; a refused promise is not an
              // error worth surfacing, the poster simply stays put.
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: 0.4 });
        vids.forEach(function (v) { io.observe(v); });

        // IntersectionObserver does not fire when the tab is backgrounded, so a
        // clip would keep looping behind another tab.
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) vids.forEach(function (v) { v.pause(); });
        });
      }

      /* ---------- rail position ----------------------------------------- */
      function maxScroll() { return rail.scrollWidth - rail.clientWidth; }

      function sync() {
        var max = maxScroll();
        var scrollable = max > 2;
        // Four short testimonials on a wide screen do not fill the rail, and a
        // pair of permanently greyed-out arrows reads as broken rather than as
        // "nothing to scroll". Hide the controls instead of disabling them.
        if (nav) nav.hidden = !scrollable;
        if (prog) prog.hidden = !scrollable;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        // 2px tolerance: fractional scrollLeft on zoomed or hi-dpi displays
        // otherwise never satisfies an exact equality and the end arrow stays
        // live forever.
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        if (bar && scrollable) {
          var frac = rail.clientWidth / rail.scrollWidth;
          var travel = (rail.clientWidth - rail.clientWidth * frac) * (rail.scrollLeft / max);
          bar.style.width = (frac * 100) + '%';
          bar.style.transform = 'translateX(' + travel + 'px)';
        }
      }

      /* ---------- arrows ------------------------------------------------ */
      function step() {
        var card = rail.querySelector('.sk-wearing__card');
        if (!card) return rail.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(rail).columnGap || '16') || 16;
        var per = Math.max(1, Math.floor(rail.clientWidth / (card.offsetWidth + gap)));
        return (card.offsetWidth + gap) * per;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* ---------- drag to scroll, mouse only ---------------------------- */
      var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
      if (fine) {
        var down = false, startX = 0, startL = 0, moved = 0;
        // Native drag-and-drop wins over pointermove otherwise: the browser
        // lifts a ghost of the card's image or link and the rail stays put.
        rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

        // Pointer capture is taken ONLY once the pointer has actually
        // travelled, never on pointerdown.
        //
        // Capture retargets every later pointer event to the rail, so with it
        // held from pointerdown the pointerup lands on the rail rather than on
        // the card. Chromium then computes the click target as the common
        // ancestor of down and up — the rail — and the anchor never sees a
        // click at all. Every card link was dead on desktop.
        //
        // Deferring it means a plain click never involves capture, while a real
        // drag gets the routing it needs the moment it becomes a drag (the
        // is-dragging rule below sets pointer-events:none on the cards, which
        // would otherwise fire pointerleave on everything the pointer just
        // left and end the drag on its first move).
        var capId = null;
        rail.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          down = true; moved = 0;
          startX = e.clientX; startL = rail.scrollLeft;
          capId = e.pointerId;
          // Snapping off now, before the first move writes scrollLeft.
          rail.classList.add('is-grab');
        });
        rail.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 4) {
            if (!moved && capId !== null) {
              try { rail.setPointerCapture(capId); } catch (err) { capId = null; }
            }
            moved = Math.abs(dx);
            rail.classList.add('is-dragging');
            rail.scrollLeft = startL - dx;
          }
        });
        function end() {
          if (!down) return;
          down = false;
          // Snapping comes back on release, which settles the rail onto a card.
          rail.classList.remove('is-dragging');
          rail.classList.remove('is-grab');
          if (capId !== null) {
            try { rail.releasePointerCapture(capId); } catch (err) {}
            capId = null;
          }
        }
        rail.addEventListener('pointerup', end);
        rail.addEventListener('pointercancel', end);
        // A drag that ends on a card must not follow its link. Capture phase,
        // so this runs before the anchor's own default action.
        rail.addEventListener('click', function (e) {
          if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
        }, true);
      }

      var raf;
      rail.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-pdp-details"] && !Shopify.designMode) return;
  try {
    
(function () {
function init(el) {
var body = el.querySelector('[data-ss-desc-body]');
var btn = el.querySelector('[data-ss-desc-toggle]');
if (!body || !btn || el.dataset.ssDescReady) return;
el.dataset.ssDescReady = '1';
function check() {
el.classList.remove('is-clamped');
var overflows = body.scrollHeight > 160;
if (overflows) {
el.classList.add('is-clamped');
btn.hidden = false;
} else {
el.classList.remove('is-open');
btn.hidden = true;
btn.setAttribute('aria-expanded', 'false');
}
}
btn.addEventListener('click', function () {
var open = el.classList.toggle('is-open');
btn.setAttribute('aria-expanded', open ? 'true' : 'false');
});
check();
var t;
window.addEventListener('resize', function () {
if (el.classList.contains('is-open')) return;
clearTimeout(t);
t = setTimeout(check, 150);
});
}
function run() { document.querySelectorAll('[data-ss-desc]').forEach(init); }
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', run);
} else {
run();
}
document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-vibeclub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
    ready(function () {
      var reveals = document.querySelectorAll('.vc-reveal');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

      var calc = document.querySelector('[data-vc-calc]');
      if (!calc) return;
      var range = calc.querySelector('[data-vc-range]');
      var amtEl = calc.querySelector('[data-vc-amt]');
      var tierEl = calc.querySelector('[data-vc-tier]');
      var noteEl = calc.querySelector('[data-vc-note]');
      var cards = Array.prototype.slice.call(document.querySelectorAll('.vc__tier'));
      var TIERS = [
        { key: 'starter', name: 'Vibe Starter', rate: 2, min: 0 },
        { key: 'rider', name: 'Vibe Rider', rate: 3, min: 5000 },
        { key: 'legend', name: 'Vibe Legend', rate: 5, min: 10000 },
        { key: 'icon', name: 'Vibe Icon', rate: 10, min: 20000 }
      ];
      function inr(n){ return '₹' + Number(n).toLocaleString('en-IN'); }
      function pick(v){ var t = TIERS[0]; for (var i = 0; i < TIERS.length; i++) { if (v >= TIERS[i].min) t = TIERS[i]; } return t; }
      function update(){
        var v = +range.value;
        var t = pick(v);
        amtEl.textContent = inr(v) + (v >= 25000 ? '+' : '');
        tierEl.textContent = t.name;
        noteEl.textContent = 'Earning ' + t.rate + '% back as VibeCoins';
        cards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-tier') === t.key); });
      }
      range.addEventListener('input', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
